import L from 'leaflet';

export default function createPolygonFromViewport(viewport) {
  const center = viewport.bounds.getCenter();
  const latlngs = [];

  latlngs.push(viewport.bounds.getSouthWest());// bottom left
  latlngs.push({ lat: viewport.bounds.getSouth(), lng: center.lng });// bottom center
  latlngs.push(viewport.bounds.getSouthEast());// bottom right
  latlngs.push({ lat: center.lat, lng: viewport.bounds.getEast() });// center right
  latlngs.push(viewport.bounds.getNorthEast());// top right
  latlngs.push({ lat: viewport.bounds.getNorth(), lng: center.lng });// top center
  latlngs.push(viewport.bounds.getNorthWest());// top left
  latlngs.push({ lat: center.lat, lng: viewport.bounds.getWest() });// center left

  return new L.polygon(latlngs).toGeoJSON(); // eslint-disable-line new-cap
}



// WEBPACK FOOTER //
// ./src/utils/createPolygonFromViewport.js